module.exports = __webpack_public_path__ + "assets/media/team-performance-graph.674c59b3.svg";